var amdi18n={"__root":{"QUEUE":"Queue","LISTENING_TO":"Listening To","RELOAD":"Reload","CUSTOMIZE":"Customize","QUEUE_INFORMATION_CANNOT_BE_FOUND":"Queue information cannot be found"},"__fr":{"QUEUE":"Liste d'écoute","LISTENING_TO":"Vous écoutez","RELOAD":"Recharger","CUSTOMIZE":"Personnaliser","QUEUE_INFORMATION_CANNOT_BE_FOUND":"Les informations sur la liste d'écoute sont introuvables"},"__en":{"QUEUE":"Queue","LISTENING_TO":"Listening To","RELOAD":"Reload","CUSTOMIZE":"Customize","QUEUE_INFORMATION_CANNOT_BE_FOUND":"Queue information cannot be found"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(typeof window !== 'undefined' && window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(typeof document !== 'undefined' && document.documentElement.lang){
				language = document.documentElement.lang;
			}else if(typeof navigator !== 'undefined' && (navigator.languages || navigator.language || navigator.userLanguage)){
				// navigator.languages does not exist in IE 11
				language = (navigator.languages && navigator.languages[0]) ||
					navigator.language ||
					navigator.userLanguage;
				language = (language || 'root').toLowerCase();
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		var recursiveFallback = function(target, source){
			for(var name in source){
				switch(typeof target[name]){
				case 'undefined':
					target[name] = source[name];
					break;
				case 'object':
					recursiveFallback(target[name], source[name]);
				}
			}
		};
		recursiveFallback(this, this.__root);
	};amdi18n.init();module.exports=amdi18n;